import { useEffect } from 'react'
import { chatbotStore } from 'store/chatbotStore'

/**
 * While the calling component is mounted, request that the support chatbot be
 * hidden, whichever provider is currently selected. Used by surfaces that must
 * exclude it but are not their own route (e.g. the pre-session quiz dialog).
 */
export function useSuppressChatbot() {
  useEffect(() => {
    chatbotStore.addSuppressor()
    return () => chatbotStore.removeSuppressor()
  }, [])
}
